import partition from 'lodash/partition';
import uniq from 'lodash/uniq';

import { Award } from 'utils/sharedStrapiQueries/sharedTypes';

export const awardsCustomSort = (items: Array<Award>) => {
  const splitArray = partition(items, e => e.featured);
  const sortFeaturedByOrder =
    splitArray[0].sort((a, b) => a.featuredOrder - b.featuredOrder) || [];

  return [sortFeaturedByOrder, splitArray[1] || []];
};

export const orderYears = (arr: Array<string>) =>
  uniq(arr)
    .map(year => {
      const number = Number(
        Array.from(year || '0')
          .filter(str => str.match(/\d+/))
          .join('')
      );

      return {
        year: number,
        strYear: year,
      };
    })
    .sort((a, b) => b.year - a.year)
    .map(({ strYear }) => strYear);
